import { render, staticRenderFns } from "./MetalColor.vue?vue&type=template&id=8b3f3a02"
import script from "./MetalColor.vue?vue&type=script&lang=js"
export * from "./MetalColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports